import React from "react"
import { Helmet } from "react-helmet"

interface SEOProps {
  title: string
}

const SEO: React.FC<SEOProps> = ({ title }) => {
  // Gatsby exposes this global at build/runtime
  const prefix = typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : ""

  return (
    <Helmet>
      <title>{title}</title>
      <link rel="icon" href={`${prefix}/favicon.ico`} type="image/x-icon" />
      <link rel="icon" href={`${prefix}/favicon.png`} type="image/png" />
      <meta name="favicon-debug" content={`✅ thesis favicon override active, prefix=${prefix}`} />
    </Helmet>
  )
}

export default SEO


// debugging if the shadowing works
// import React from "react"
// import { Helmet } from "react-helmet"

// const SEO = ({ title }: { title: string }) => {
//   const prefix =
//     typeof window !== "undefined"
//       ? window.__PATH_PREFIX__ || ""
//       : process.env.PATH_PREFIX || "" // this is wrong!!!!!

//   return (
//     <Helmet>
//       <title>{title}</title>
//       <link rel="icon" href={`${prefix}/favicon.ico`} />
//       <meta name="seo-debug" content="✅ using shadowed SEO.tsx" />
//     </Helmet>
//   )
// }

// export default SEO

